import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import _ from 'lodash';
import { convertMillisToHMS } from '../../utils/bookFormUtilities';
import { getBookTreeElement, fetchFullBook } from '../../slices/storyEditorSlice';

import { AuthStdFooter } from "../../utils/auth-std-footer";
const FillVariations = ({ onVariationClick, isOpen }) => {
  const dispatch = useDispatch();
  const userProfile = useSelector(state => state.user.profile);

  const [hasBookStatistics, setHasBookStatistics] = useState([]);
  const [hasProcessedVersionItems, setHasProcessedVersionItems] = useState([]);
  const [hasBook, setHasBook] = useState({});

  const fetchData = useCallback(async () => {
    try {
      const bookItem = await dispatch(getBookTreeElement('HAS_BOOK')).unwrap();
      setHasBook(bookItem);

      const statisticItems = await dispatch(getBookTreeElement('HAS_BOOK_STATISTICS')).unwrap();
      setHasBookStatistics(statisticItems);

      const processedVersionItems = await dispatch(getBookTreeElement('HAS_PROCESSED_VERSION')).unwrap();
      setHasProcessedVersionItems(processedVersionItems);

      if (bookItem && bookItem.uuid) {
        await dispatch(fetchFullBook({ userId: userProfile.data.userId, bookUuid: bookItem.uuid })).unwrap();
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }, [dispatch, userProfile.data.userId]);

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
  }, [fetchData, isOpen]);

  const handleVariationClick = (item) => {
    onVariationClick(item);

  };

  const generateContent = () => {
    if (_.isEmpty(hasBook)) {
      return <div>Please Select a Story</div>;
    }
    if (_.isEmpty(hasProcessedVersionItems)) {
      return <div>No Versions found</div>;
    }

    const fillHeader = (fileName, index) => (
      <React.Fragment key={`header-${fileName}-${index}`}>
        <Grid.Row className='noPadTop noPadBottom' style={{ backgroundColor: "#ECECEC" }}>
          <Grid.Column className='listHeader' textAlign="left" width={2} style={{ fontWeight: "600" }}>Filename:</Grid.Column>
          <Grid.Column width={14} style={{ fontWeight: "600" }}>{fileName}</Grid.Column>
        </Grid.Row>
        <Grid.Row className='noPadTop noPadBottom'>
          <Grid.Column className='listHeader' textAlign="center" width={1}>Ver</Grid.Column>
          <Grid.Column className='listHeader noPadLeft noPadRight' textAlign="center" width={2}>Time</Grid.Column>
          <Grid.Column className='listHeader noPadLeft noPadRight' textAlign="center" width={4}>Created On</Grid.Column>
          <Grid.Column className='listHeader' textAlign="center" width={4}>Thumbnail</Grid.Column>
          <Grid.Column className='listHeader noPadLeft noPadRight' textAlign="right" width={5}>Tokens: prompt | complete | total</Grid.Column>
        </Grid.Row>
      </React.Fragment>
    );

    const fillVersionList = (items) => {
      let variationList = [];
      let currentFileName = "";
      let headerIndex = 0;

      _.forEach(items, (item, index) => {
        if (item.fileName !== currentFileName) {
          variationList.push(fillHeader(item.fileName, headerIndex++));
          currentFileName = item.fileName;
        }
        let timeHMS = convertMillisToHMS(item.processTime);
        variationList.push(
          <Grid.Row divided key={`verItem-${item.uuid}-${index}`} className='flex-container noPadTop noPadBottom hover-pointer' onClick={() => handleVariationClick(item)}>
            <Grid.Column className="" textAlign="center" width={1}>{item.version}</Grid.Column>
            <Grid.Column className="noPadLeft noPadRight" textAlign="center" width={2}>{timeHMS}</Grid.Column>
            <Grid.Column className="noPadLeft" textAlign="right" width={4}>{new Date(item.createdOn).toLocaleString()}</Grid.Column>
            <Grid.Column className="ellipsis" textAlign="left" width={4}>{item.thumbnail}</Grid.Column>
            <Grid.Column className='listHeader noPadLeft noPadRight' textAlign="right" width={5}>{item.prompt_tokens} | {item.completion_tokens} | {item.total_tokens}</Grid.Column>
          </Grid.Row>
        );
      });
      return variationList;
    };

    return (
      <>
        <Grid className="topGrid" style={{ width: "700px" }}>
          <Grid.Row className='noPadTop noPadBottom'>
            <Grid.Column className='listHeader' style={{ fontWeight: "600" }} textAlign="center" width={9}>Book Title: {hasBook.name}</Grid.Column>
            <Grid.Column style={{ fontWeight: "600" }} textAlign="right" width={7}>Token Totals: {hasBookStatistics?.promptTokens || "0"} | {hasBookStatistics?.completionTokens || "0"} | {hasBookStatistics?.totalTokens || "0"}</Grid.Column>
          </Grid.Row>

        </Grid>
        <div className="scrollable-container" style={{ marginBottom: "70px" }}>
          <Grid className="topGrid" style={{ width: "700px" }}>
            {fillVersionList(hasProcessedVersionItems)}
          </Grid>
        </div>
      </>
    );
  };

  return generateContent();
};

export default FillVariations;
